import {View} from 'MWC';
import tpl from '../templates/Hero.jsx';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    static contextTypes = {
        theme: PropTypes.string
    };
}
